module.exports = __webpack_public_path__ + "static/media/icon_13.b2be6e11.svg";